exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".filter {\n  margin-bottom: 2rem;\n}\n.filter .filter__name {\n  margin-right: 0.5rem;\n  text-transform: uppercase;\n}\n", ""]);

